function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .menu-acc-wrapper {\n    z-index: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    .acc-title-icon-wrapper {\n      padding: 0 15px 0 5px;\n      margin-right: 10px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';
import Accordion from '../Accordion';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var MenuListWrapper = styled.div(_templateObject());
var MenuList = memo(function (_ref) {
  var menuItems = _ref.menuItems,
      onClickHandler = _ref.onClickHandler,
      rest = _objectWithoutPropertiesLoose(_ref, ["menuItems", "onClickHandler"]);

  return /*#__PURE__*/React.createElement(MenuListWrapper, rest, menuItems.map(function (item) {
    if (!item.isExpandable) {
      return /*#__PURE__*/React.createElement(MenuItem, _extends({}, item, {
        key: item.name,
        onClickHandler: onClickHandler
      }));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-acc-wrapper",
        key: item.name
      }, /*#__PURE__*/React.createElement(Accordion, {
        titleIcon: item.iconName,
        title: item.name,
        key: item.name,
        clickHandler: function clickHandler() {}
      }, item.list && item.list.map(function (childItem) {
        return /*#__PURE__*/React.createElement(MenuItem, _extends({
          key: childItem.name
        }, childItem));
      })));
    }
  }));
});
MenuList.propTypes = process.env.NODE_ENV !== "production" ? {
  menuItems: PropTypes.array
} : {};
MenuList.defaultProp = {
  theme: defaultTheme
};
export default MenuList;